import { ReportsApiReportsControllerGetOrganizationsReportRequest } from '@givz/core-client';
import { useState } from 'react';
import { useCoreClientQuery } from './client';

export const reportsKeys = {
  base: ['reports'] as const,
  organizations: (
    args: ReportsApiReportsControllerGetOrganizationsReportRequest,
  ) => [...reportsKeys.base, 'organizations', { args }] as const,
};

export const useOrganizationReports = (
  args: ReportsApiReportsControllerGetOrganizationsReportRequest = {},
) => {
  const [searchParams, setSearchParams] =
    useState<ReportsApiReportsControllerGetOrganizationsReportRequest>(args);

  return [
    useCoreClientQuery({
      keepPreviousData: true,
      queryFn: (client) => (_queryContext) =>
        client.Reports.organizations(searchParams),
      queryKey: reportsKeys.organizations(searchParams),
    }),
    setSearchParams,
  ] as const;
};
